import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { Provider } from "react-redux";
import App from './App.tsx'
import { store } from "store";
import { isDesktop, isMobile } from 'react-device-detect';
import ErrorBoundary from 'components/ErrorBoundary';

import "configs/customTags";

sessionStorage.removeItem("save_open")


isMobile && document.documentElement.classList.add('mobile');
isDesktop && document.documentElement.classList.add('desktop');

createRoot(document.getElementById('root')!).render(
    <Provider store={store}>
        <ErrorBoundary>
            <StrictMode>
                <App />
            </StrictMode>
        </ErrorBoundary>
    </Provider>,
)
